import { useCallback } from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { Field } from 'react-final-form';

import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { Button } from 'UIPackage/MainModule/components/Button';
import { DatePickerField } from 'UIPackage/MainModule/components/DatePickerField';
import { Row } from 'UIPackage/FormModule/components/Row';
import {
  IKnmErknmFormViolation,
  IViolationFixPlanDateItem,
} from 'KnmErknmPackage/ErknmViolationsModule/interfaces/IKnmErknmFormViolation';
import { ViolationStatusesEnum } from 'APIPackage/KnmModule/enums/ViolationStatusesEnum';
import { CloseButton } from 'UIPackage/MainModule/components/CloseButton';

interface IErknmDecisionViolationFixPlanDatesFieldProps {
  fieldName: string;
  formRef: IKnmFormRef | undefined;
  violation: IKnmErknmFormViolation;
  watchOnly: boolean;
}

export const ErknmDecisionViolationFixPlanDatesField = ({
  fieldName,
  formRef,
  violation,
  watchOnly,
}: IErknmDecisionViolationFixPlanDatesFieldProps) => {
  const datesFieldName = `${fieldName}.fixPlanDates`;
  const fixPlanDatesRequiredFieldName = `${fieldName}.fixPlanDatesRequired`;

  const push = formRef?.current.mutators.push;
  const remove = formRef?.current.mutators.remove;
  const isOnApproval: boolean = violation.status === ViolationStatusesEnum.APPROVING;
  const isNotFixedByStatus: boolean = violation.status === ViolationStatusesEnum.NOT_FIXED;
  const isNewPlanDateAdded: boolean = !!violation.fixPlanDates?.[violation.fixPlanDates?.length - 1]?.isNew;

  const handleAdd = useCallback(() => {
    const newDateItem: IViolationFixPlanDateItem = {
      isNew: true,
      value: '',
      guid: null,
      dateCreate: null,
    };

    push && push(datesFieldName, newDateItem);
  }, []);
  const handleRemove = useCallback(
    (idx: number) => () => {
      remove && remove(datesFieldName, idx);
    },
    [],
  );

  return (
    <>
      <FieldBlock
        label="Плановая дата устранения"
        labelFontSize="small"
        color="black"
        button={
          isNotFixedByStatus && !isOnApproval && !watchOnly ? (
            <Button
              className="shared-btn-add"
              text="Добавить"
              type="button"
              variant="link"
              color="primary"
              onClick={handleAdd}
              disabled={isNewPlanDateAdded}
            />
          ) : undefined
        }
      />
      <FieldArray name={datesFieldName}>
        {({ fields }) => {
          return (
            <>
              {fields.map((dateFieldName, index) => {
                const dateValue: IViolationFixPlanDateItem = fields.value[index];

                return (
                  <Row key={dateFieldName} notSpace>
                    <FieldBlock size="half">
                      <DatePickerField
                        name={`${dateFieldName}.value`}
                        placeholder="Выберите дату и время"
                        disabled={!dateValue.isNew}
                      />
                    </FieldBlock>
                    {dateValue.isNew && (
                      <CloseButton className="shared-deleting-row-btn" onClick={handleRemove(index)} />
                    )}
                  </Row>
                );
              })}
              <Field name={fixPlanDatesRequiredFieldName}>
                {({ meta }) => {
                  if (typeof meta.error === 'string' && meta.touched) {
                    return <p className="shared-input-error shared-row__small-margin">{meta.error}</p>;
                  }
                }}
              </Field>
            </>
          );
        }}
      </FieldArray>
    </>
  );
};
